






































































import { Component, Vue } from "vue-property-decorator";
import { HandbookCategoryResponseList } from "@/api";
import loading from "@/components/loader/loading.vue";

@Component({
  components: {
    loading,
  },
})
export default class CategoryList extends Vue {
  loading = false;

  async created() {
    this.loading = true;
    await this.$store.dispatch("handbook/fetchCategories");
    this.loading = false;
  }

  get categories() {
    return (
      (this.$store.getters[
        "handbook/categories"
      ] as HandbookCategoryResponseList) || []
    );
  }

  isActive(id: number, subId = 0): boolean {
    const currentId = Number(this.$route.query.categoryId) || 0;
    const currentSubId = Number(this.$route.query.subCategoryId) || 0;
    return id === currentId && subId === currentSubId;
  }

  selectCategory(id: number, subId = 0) {
    this.$router.push({
      path: `/handbook/details`,
      query: {
        categoryId: `${id}`,
        subCategoryId: `${subId || undefined}`,
      },
    });
  }
}
